
  import { defineComponent, ref, computed } from "vue";
  import { MemberApi } from "@/services/Api";
  import { useAsyncSpinner } from "@/services/Spinner";
  import { UseI18nOptions, useI18n } from "vue-i18n";
  
  export default defineComponent({
    props: {
      redirect: {
        type: String,
        required: true,
      },
      policy: {
        type: String,
        required: true,
      }
    },
    setup(props) {
      const registerModel = {
        name: "",
        lastName:"",
        email: "",
        line1: "",
        zip: "",
        city: "",
        country: "",
        mobilePhone: "",
        password: "",
        confirmPassword: ""
      };
      const { t } = useI18n();
      const errorMessage = ref<string>();
      const success = ref(false);

      const baseUrl = computed(() => {
        return window.location.origin;
      });

      const isFormValid = () => {
        if (!registerModel.name ||
            !registerModel.lastName || 
            !registerModel.email || 
            !registerModel.line1 || 
            !registerModel.zip ||
            !registerModel.city || 
            !registerModel.country || 
            !registerModel.mobilePhone && registerModel.mobilePhone.length !== 10 ||
            !registerModel.password || 
            !registerModel.confirmPassword || 
            registerModel.password !== registerModel.confirmPassword) {
          return false;
        } else {
          return true;
        }
      };
  
      const onSubmit = async () => {
        success.value = false;
        errorMessage.value = undefined;
        const urlParams = new URLSearchParams(window.location.search);
        const redirect = urlParams.get("redir");
        await useAsyncSpinner(async () => {
          if (!registerModel.name) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.lastName) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.email) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.line1) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.zip) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.city) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.country) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }

          if (!registerModel.mobilePhone && registerModel.mobilePhone.length !== 10) {
            errorMessage.value = t('Registererror.AllFieldsRequired');
            return;
          }
            
          if (registerModel.password !== registerModel.confirmPassword) {
              errorMessage.value = t('Registererror.Passwordmatch');
              return;
          }

          if (registerModel.password.length < 10) {
              errorMessage.value =  t('Registererror.Passwordlength');
              return;
          }
            
          const model = await MemberApi.register(registerModel);
          if (model.success) {
            success.value = true;
            const loggedInModel = await MemberApi.login(registerModel.email, registerModel.password);
            if (redirect) {
              location.assign(window.location.origin+redirect);
            } 
            else {
              location.reload();
            }
          }
          else {
            success.value = false;
            errorMessage.value = model.message;
          }
        });
      };
  
      return {
        registerModel,
        success,
        errorMessage,
        baseUrl,
        isFormValid,
        onSubmit
      };
    },
    methods: {
    validatePhone(value) {
      if (!value || value.length !== 10) {
        return false;
      }

      const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i;
      return regex.test(value);
    }
  }
  });
  